import React, { useEffect, useState } from 'react'
import './Promotion.scss'

import video from '../../../assets/Pictures/videoTr.svg'
import catalog from '../../../assets/Pictures/productCatalog.svg'
import newsletter from '../../../assets/Pictures/newsletter.svg'
import longArrow from '../../../assets/Pictures/longArrow.svg'

import 'aos/dist/aos.css'
import Aos from 'aos'
import { Link } from 'react-router-dom'

import ReactPlayer from 'react-player'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export default function Promotion() {
  const [email, setEmail] = useState('')
  const [menu, setMenu] = useState(false)
  const [videoFrame, setVideoFrame] = useState(false)
  const [playVideo, setPlayVideo] = useState(false)

  useEffect(() => {
    Aos.init({ duration: 2000, once: true })
  }, [])

  const emailHandler = () => {
    if (email.length > 5 && email.includes('@')) {
      toast.success('thank you for join', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    } else {
      toast.error('email address wrong', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })    
    }
  }

  const VideoHandler = () => {
    setMenu(true)
    setVideoFrame(true)
    setPlayVideo(true)
  }

  const VideoHandlerCancel = () => {
    setMenu(false)
    setVideoFrame(false)
    setPlayVideo(false)
  }

  return (
    <>
      <ToastContainer />
      <div className="cover" onClick={VideoHandlerCancel} style={menu ? { display: '' } : { display: 'none' }}>
      </div>
      <div className="video" style={videoFrame ? { display: '' } : { display: 'none' }}>
        <ReactPlayer style={{ display: 'flex', justifyContent: 'center', margin: 'auto' }} playing={playVideo} url='https://tfmenu.storage.iran.liara.space/Promotion.mp4' />
      </div>
      <div className='promotion' data-aos='fade-down'>
        <div className='container'>
          <div className='row'>
            <div className='promotion_video' onClick={VideoHandler}>
              <img src={video} alt='video' />
            </div>
            <div className='promotion_parts'>
              <div className='promotion_catalog'>
                <div className='left'>
                  <img src={catalog} alt='catalog' />
                </div>
                <div className='contents'>
                  <div className='top'>
                    Kataloğumuzu inceleyebilir ve bilgisayarınıza indirebilirsiniz.
                  </div>
                  <div className='bottom'>
                    <div className='text'>
                      İndirme link
                    </div>
                    <div className='arrow'>
                      <img src={longArrow} alt='longArrow' />
                    </div>
                    <Link target='_blank' to='https://tfmenu.storage.iran.liara.space/FinalInvestment.pdf' className='button' >
                      İndirmek
                    </Link>
                  </div>
                </div>
              </div>
              <div className='promotion_newsletter'>
                <div className='left'>
                  <img src={newsletter} alt='newsletter' />
                </div>
                <div className='contents'>
                  <div className='top'>
                    Duyurularımızdan haberdar olmak için e-posta listemize kayıt olabilirsiniz.
                  </div>
                  <div className='bottom'>
                    <div className='input'>
                      <input type='email' name='' id='' placeholder='Email Address' onChange={e => setEmail(e.target.value)} />
                    </div>
                    <div className='button' onClick={emailHandler}>
                      <button>Göndermek</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    
  )
}
